import { AUTH_JWT_KEY } from './constants';

export const logout = async () => {
  localStorage.removeItem(AUTH_JWT_KEY);
  await fetch('/next-api/logout', { method: 'POST' });
  window.location.href = '/auth';
};

export const stopImitatingUser = async () => {
  await fetch(`/next-api/imitate-user?userId=`, {
    credentials: 'same-origin',
  });
  window.location.href = '/';
};
